import React from "react";

const PageNotFound = () => {
  return <div>Page Not found</div>;
};

export default PageNotFound;
